import React from 'react';
import { Stack, MenuItem, Divider, Typography } from '@mui/material';

import { Strings } from '@app/constants';
import { RHFTextField } from '@app/components';
import useResponsive from '@app/hooks/use-responsive';

interface props {
  additionalButton?: React.ReactNode; // Define the additional button prop
  labelSuffix?: boolean;
}
const BankInformationForm = ({ additionalButton, labelSuffix }: props) => {
  const isMobile = useResponsive('up', 'sm');
  const direction = isMobile ? 'row' : 'column';

  const getLabelWithSuffix = (label: string) => {
    return labelSuffix ? `${label} *` : label;
  };

  return (
    <Stack spacing={2} flexGrow={1} pb={2}>
      <Stack>
        <Typography variant="h5">{Strings.profile.bankInformation}</Typography>
      </Stack>
      <Divider />

      <Stack direction={direction} spacing={2}>
        <RHFTextField
          name="bankInfo.bankInformation.accountHolderName"
          label={getLabelWithSuffix(Strings.field.accountHolderName)}
        />
        <RHFTextField
          name="bankInfo.bankInformation.fatherName"
          label={getLabelWithSuffix(Strings.field.fatherName)}
        />
      </Stack>
      <Stack direction={direction} spacing={2}>
        <RHFTextField
          name="bankInfo.bankInformation.bankName"
          label={getLabelWithSuffix(Strings.field.bankName)}
        />
        <RHFTextField
          name="bankInfo.bankInformation.ifscCode"
          label={getLabelWithSuffix(Strings.field.ifsc)}
        />
        <RHFTextField
          name="bankInfo.bankInformation.accountType"
          label={getLabelWithSuffix(Strings.field.accountType)}
          select
        >
          <MenuItem value={Strings.field.saving}>{Strings.field.saving}</MenuItem>
          <MenuItem value={Strings.field.current}>{Strings.field.current}</MenuItem>
          <MenuItem value={Strings.field.student}>{Strings.field.student}</MenuItem>
        </RHFTextField>
      </Stack>
      <Stack direction={direction} spacing={2}>
        <RHFTextField
          name="bankInfo.bankInformation.accountNumber"
          label={getLabelWithSuffix(Strings.field.accountNumber)}
        />
        <RHFTextField
          name="bankInfo.bankInformation.reenterAccountNumber"
          label={getLabelWithSuffix(Strings.field.reenterAccountNumber)}
        />
      </Stack>
      <Stack alignItems={'flex-start'}>{additionalButton}</Stack>
    </Stack>
  );
};

export { BankInformationForm };
